export const THDLinkStyles = {
    root: {
        color: '#212120',
        fontSize: '16px',
    },
};
